<template>
  <div class="add_warp">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      class="fromData"
      label-position="right"
      label-width="47%"
    >
      <el-form-item label="客户名称" prop="customername" style="width:50%">
        <el-input v-model="ruleForm.customername"></el-input>
      </el-form-item>
      <!-- <el-form-item label="省市县" prop="name" style="width:50%">
        <el-cascader v-model="value" :options="options" :props="{label:'districtname', value: 'districtid', children:'child', leaf:'child', emitPath: false}"></el-cascader>
      </el-form-item>-->
      <el-form-item label="详细地址" prop="address" style="width:50%">
        <el-input v-model="ruleForm.address"></el-input>
      </el-form-item>
      <el-form-item label="经度" style="width:50%">
        <el-input v-model="ruleForm.longitude"></el-input>
      </el-form-item>
      <el-form-item label="纬度" style="width:50%">
        <el-input v-model="ruleForm.latitude"></el-input>
      </el-form-item>
      <el-form-item label="组织证件" prop="name" style="width:50%">
        <el-upload
          class="upload-demo"
          action="#"
          :before-remove="beforeRemove"
          multiple
          :limit="1"
          :auto-upload="false"
          :on-change="myupload"
          :file-list="ZfileList"
          list-type="picture"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="组织宣传封面" prop="name" style="width:50%">
        <el-upload
          class="upload-demo"
          action="#"
          :before-remove="beforeRemove"
          multiple
          :limit="1"
          :on-change="uploadXc"
          :auto-upload="false"
          :file-list="MfileList"
          list-type="picture"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="组织平面图片" prop="name" style="width:50%">
        <el-upload
          class="upload-demo"
          action="#"
          :limit="1"
          :on-change="flatpictureUpload"
          :auto-upload="false"
          :before-remove="beforeRemove"
          multiple
          :file-list="fileList"
          list-type="picture"
        >
          <el-button size="small" type="primary">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <!-- <el-form-item label="可用短信数量"  style="width:50%">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>-->
      <el-form-item label="备注" style="width:50%">
        <el-input
          type="textarea"
          :autosize="{ minRows: 2, maxRows: 4}"
          placeholder="请输入内容"
          v-model="ruleForm.remark"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="btenEtiel">
    <span slot="footer" class="dialog-footer list" v-if="isAdd">
      <el-button @click="dialogVisiblecs">取 消</el-button>
      <el-button type="primary" @click="dialogVisibleConft">确 定</el-button>
    </span>
    </div>
     <div style="display:none">{{certificates}}{{coverphoto}}{{coverphoto}}</div>
  </div>
</template>
<script>
import { autoUpload, customerAadd } from "../../../network/index";
export default {
  props: {
    hidechile: {
      type: Function,
      default() {
        return Function;
      }
    },
    isAdd: {
      type: Boolean,
      default() {
        return true;
      }
    },
    ruleForm: {
      type: Object,
      default: {}
    },
    customerlist: {
      type: Function,
      default() {
        return Function;
      }
    }
  },
  data() {
    return {
      fileList: [],
      MfileList: [], //组织宣传封
      ZfileList: [], //组织证件
      rules: {
        customername: [
          { required: true, message: "请输入客户名称", trigger: "blur" }
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }]
      },
      value: []
    };
  },
  computed:{
 // 组织证件
    certificates() {
      let flys =
        this.ruleForm.certificates == ""
          ? false
          : this.ruleForm.certificates == null
          ? false
          : this.ruleForm.certificates;
      if (flys) {
        return this.ZfileList.push({ url: this.ruleForm.certificates });
      }
    },
    //组织宣传封面
    coverphoto() {
      let flys =
        this.ruleForm.coverphoto == ""
          ? false
          : this.ruleForm.coverphoto == null
          ? false
          : this.ruleForm.coverphoto;
      if (flys) {
        return this.MfileList.push({ url: this.ruleForm.coverphoto });
      }
    },
    //组织平面图片
    flatpicture() {
      let flys =
        this.ruleForm.flatpicture == ""
          ? false
          : this.ruleForm.flatpicture == null
          ? false
          : this.ruleForm.flatpicture;
      if (flys) {
        return this.fileList.push({ url: this.ruleForm.flatpicture });
      }
    }
  },
  mounted() {},
  methods: {
    // 组织证件
    myupload(file) {
      let files = file.raw;
      this.updata(files, 1);
    },
    // 宣传图片
    uploadXc(file) {
      let files = file.raw;
      this.updata(files, 2);
    },
    //平面图片
    flatpictureUpload(file) {
      let files = file.raw;
      this.updata(files, 3);
    },
    // 上传图片的公共方法
    async updata(file, id) {
      const lang_file = sessionStorage.getItem("lang_file");
      const token = sessionStorage.getItem("token");
      let formData = new FormData();
      formData.append("image", file);
      formData.append("appid", token);
      formData.append("lang_file", lang_file);
      const res = await autoUpload(formData);
      // console.log(res);
      if (res.code) {
        switch (id) {
          case 1:
            this.ruleForm.certificates = res.data;
            break;
          case 2:
            this.ruleForm.coverphoto = res.data;
            break;
          case 3:
            this.ruleForm.flatpicture = res.data;
            break;
        }
      } else {
        this.$message.error("上传失败,请联系工作人员");
      }
    },
    // 删除图片
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 取消
    dialogVisiblecs() {
      this.hidechile();
    },
    //确定
    async dialogVisibleConft() {
      if (this.ruleForm.id == undefined) {
        const { code, msg } = await customerAadd(this.ruleForm);
        if (code) {
          this.customerlist(); //更新数据列表
          this.ruleForm = {};
          this.hidechile();
          this.$message.success(msg);
        } else {
          this.$message.error(msg);
        }
      } else {
          const {code,msg} = await customerAadd(this.ruleForm)
          if(code){
              this.hidechile();
              this.$message.success(msg);
          }else{
              this.$message.success(msg);
          }
          
          // console.log(code);
          
      }
    }
  }
};
</script>
<style  scoped>
.fromData {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.list {
  display: flex;
  justify-content: center;
}
</style>